export default function ServicesCta() {
  return (
    <section id="services-cta" className="relative overflow-hidden py-24">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20abstract%20teal%20and%20dark%20green%20gradient%20technology%20texture%20with%20soft%20flowing%20data%20streams%20and%20subtle%20geometric%20grid%2C%20calm%20minimal%20corporate%20background%20for%20a%20call%20to%20action%20banner%2C%20smooth%20cinematic%20lighting%2C%20clean%20uncluttered%20composition&width=1800&height=700&seq=acu-services-cta-01&orientation=landscape"
        className="absolute inset-0 w-full h-full object-cover object-top"
        alt="Contact Acu-Comp IT services"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/92 via-primary-900/85 to-primary-950/92"></div>
      <div className="relative max-w-5xl mx-auto px-4 md:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-background-50 leading-tight">
          Not sure which service you actually need?
        </h2>
        <p className="text-background-100/90 mt-5 max-w-2xl mx-auto">
          Start with a free IT assessment. We&apos;ll look at your compute, storage, and security posture and tell
          you plainly what to fix first — even if it isn&apos;t with us.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/#contact"
            className="bg-accent-500 hover:bg-accent-600 text-foreground-950 font-semibold px-8 py-4 rounded-md whitespace-nowrap cursor-pointer transition inline-flex items-center gap-2"
          >
            Request Free Assessment <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:18007800632"
            className="border border-background-50/40 text-background-50 hover:bg-background-50/10 font-semibold px-8 py-4 rounded-md whitespace-nowrap cursor-pointer transition inline-flex items-center gap-2"
          >
            <i className="ri-phone-line"></i> 1-800-780-0632
          </a>
        </div>
      </div>
    </section>
  );
}